import mobilIcon from "../../assets/MOBILE ICON.png"
import bazar from "../../assets/bazar.png"
import android from "../../assets/android.png"
import pwa from "../../assets/pwa.png"
import androidM from "../../assets/android 1 (1).png"
import android2 from "../../assets/android 2.png"
import bazarM from "../../assets/bazar 1.png"
import { Link } from "react-router-dom"

const Application = () => {
    return (
        <div className=' koja-Application'>
        <div className="black-strip2 d-none d-md-flex justify-content-center align-items-center" style={{marginRight:"75px"}}>
        <div className='koja-Applocation-label text-nowrap d-none d-md-block'>
        <h3>دانلود اپلیکیشن کجا</h3>
        <h6>جهت دانلود اپلیکیشن موبایل کجا نسخه اندورید از یکی از روش های زیر استفاده کنید</h6>
        <div className="d-flex flex-column " style={{transform: "rotate(90deg)" , height:"100px" , width:"100px"}}>
        <a  href="https://cafebazaar.ir/app/ir.kojanajafabad.koja"><img alt="" width={100}  src={bazar}/></a>
        <a href='https://koja-najafabad.ir/api/v1/file/app/koja'><img alt="" width={100} src={android2}/></a>
        </div>
        <h6>از دکمه زیر استفاده کنید. جهت دانلود نسخه وب پیشرو مخصوص کاربران  ios</h6>
        <div className="d-flex flex-column " style={{transform: "rotate(90deg)" , height:"100px" , width:"100px"}}>
        <a href="https://pwa.koja-najafabad.ir/" target="_blank" rel="bazar"> <img alt="" width={100}  src={android}/></a>
        </div>
        </div>
        <h4 className='koja-servises-label text-nowrap d-md-none' style={{fontSize:"50px"}}>اپلیکیشن کجا</h4>
        </div>
        <div className="d-blocke d-md-none koja-Application-mobile">
        <p>جهت دانلود نسخه وب پیشرو مخصوص کاربران ios از دکمه زیر استفاده کنید</p>
        <a href="https://pwa.koja-najafabad.ir/" target="_blank"><img alt="" width={100}  src={pwa}/></a>
        <p>جهت دانلود اپلیکیشن موبایل کجا نسخه اندروید از یکی از روش های زیر استفاده کنید</p>
        <div className="d-flex justify-content-center">
        <a href="https://koja-najafabad.ir/api/v1/file/app/koja" rel="pwa"><img alt="" width={100}  src={androidM}/></a>
        <a href="https://cafebazaar.ir/app/ir.kojanajafabad.koja" target="_blank" ><img alt="" width={100}  src={bazarM}/></a>
        </div>
        </div>
        </div>
    );
};

export default Application;